import { isTriggerBack } from "barba"

const body = document.body
const selector = 'img[data-loaded-class]'

function ImgLoadedClass(img) {
    let classes = img.dataset.loadedClass
    classes = classes.replace(/\s+/g, " ")
    classes = classes.split(" ")
    classes.push(isTriggerBack() ? 'is-back' : 'is-foward')
    img.classList.add(...classes)
}

body.addEventListener(
    'load',
    e => {
        if (e.target.matches(selector)) {
            ImgLoadedClass(e.target)
        }
    },
    true // Use capture, image load event won't bubble up
)

body.querySelectorAll(selector).forEach(img => {
    if (img.complete) {
        ImgLoadedClass(img)
    }
})
